import { Logging } from "@/data/util/Logging";

export function logInformation(message) {
    Logging.LogInfo(message);
}

export function logWarning(message) {
    Logging.LogWarning(message);
}
